var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDots5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 44,
    viewBox: "0 0 1440 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75,
    clipPath: "url(#clip0_1_9298)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1_9298)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M254.04 16.93C255.122 16.93 256 16.0525 256 14.97C256 13.8875 255.122 13.01 254.04 13.01C252.958 13.01 252.08 13.8875 252.08 14.97C252.08 16.0525 252.958 16.93 254.04 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M254.04 34.93C255.122 34.93 256 34.0525 256 32.97C256 31.8875 255.122 31.01 254.04 31.01C252.958 31.01 252.08 31.8875 252.08 32.97C252.08 34.0525 252.958 34.93 254.04 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M236.03 16.93C237.112 16.93 237.99 16.0525 237.99 14.97C237.99 13.8875 237.112 13.01 236.03 13.01C234.948 13.01 234.07 13.8875 234.07 14.97C234.07 16.0525 234.948 16.93 236.03 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M236.03 34.93C237.112 34.93 237.99 34.0525 237.99 32.97C237.99 31.8875 237.112 31.01 236.03 31.01C234.948 31.01 234.07 31.8875 234.07 32.97C234.07 34.0525 234.948 34.93 236.03 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M218.03 16.93C219.112 16.93 219.99 16.0525 219.99 14.97C219.99 13.8875 219.112 13.01 218.03 13.01C216.948 13.01 216.07 13.8875 216.07 14.97C216.07 16.0525 216.948 16.93 218.03 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M218.03 34.93C219.112 34.93 219.99 34.0525 219.99 32.97C219.99 31.8875 219.112 31.01 218.03 31.01C216.948 31.01 216.07 31.8875 216.07 32.97C216.07 34.0525 216.948 34.93 218.03 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M200.02 16.93C201.102 16.93 201.98 16.0525 201.98 14.97C201.98 13.8875 201.102 13.01 200.02 13.01C198.938 13.01 198.06 13.8875 198.06 14.97C198.06 16.0525 198.938 16.93 200.02 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M200.02 34.93C201.102 34.93 201.98 34.0525 201.98 32.97C201.98 31.8875 201.102 31.01 200.02 31.01C198.938 31.01 198.06 31.8875 198.06 32.97C198.06 34.0525 198.938 34.93 200.02 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M182.02 16.93C183.102 16.93 183.98 16.0525 183.98 14.97C183.98 13.8875 183.102 13.01 182.02 13.01C180.938 13.01 180.06 13.8875 180.06 14.97C180.06 16.0525 180.938 16.93 182.02 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M182.02 34.93C183.102 34.93 183.98 34.0525 183.98 32.97C183.98 31.8875 183.102 31.01 182.02 31.01C180.938 31.01 180.06 31.8875 180.06 32.97C180.06 34.0525 180.938 34.93 182.02 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M164.01 16.93C165.092 16.93 165.97 16.0525 165.97 14.97C165.97 13.8875 165.092 13.01 164.01 13.01C162.928 13.01 162.05 13.8875 162.05 14.97C162.05 16.0525 162.928 16.93 164.01 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M164.01 34.93C165.092 34.93 165.97 34.0525 165.97 32.97C165.97 31.8875 165.092 31.01 164.01 31.01C162.928 31.01 162.05 31.8875 162.05 32.97C162.05 34.0525 162.928 34.93 164.01 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M146.01 16.93C147.092 16.93 147.97 16.0525 147.97 14.97C147.97 13.8875 147.092 13.01 146.01 13.01C144.928 13.01 144.05 13.8875 144.05 14.97C144.05 16.0525 144.928 16.93 146.01 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M146.01 34.93C147.092 34.93 147.97 34.0525 147.97 32.97C147.97 31.8875 147.092 31.01 146.01 31.01C144.928 31.01 144.05 31.8875 144.05 32.97C144.05 34.0525 144.928 34.93 146.01 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M128 16.93C129.082 16.93 129.96 16.0525 129.96 14.97C129.96 13.8875 129.082 13.01 128 13.01C126.917 13.01 126.04 13.8875 126.04 14.97C126.04 16.0525 126.917 16.93 128 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M128 34.93C129.082 34.93 129.96 34.0525 129.96 32.97C129.96 31.8875 129.082 31.01 128 31.01C126.917 31.01 126.04 31.8875 126.04 32.97C126.04 34.0525 126.917 34.93 128 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M109.99 16.93C111.073 16.93 111.95 16.0525 111.95 14.97C111.95 13.8875 111.073 13.01 109.99 13.01C108.908 13.01 108.03 13.8875 108.03 14.97C108.03 16.0525 108.908 16.93 109.99 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M109.99 34.93C111.073 34.93 111.95 34.0525 111.95 32.97C111.95 31.8875 111.073 31.01 109.99 31.01C108.908 31.01 108.03 31.8875 108.03 32.97C108.03 34.0525 108.908 34.93 109.99 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M91.99 16.93C93.0725 16.93 93.95 16.0525 93.95 14.97C93.95 13.8875 93.0725 13.01 91.99 13.01C90.9076 13.01 90.03 13.8875 90.03 14.97C90.03 16.0525 90.9076 16.93 91.99 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M91.99 34.93C93.0725 34.93 93.95 34.0525 93.95 32.97C93.95 31.8875 93.0725 31.01 91.99 31.01C90.9076 31.01 90.03 31.8875 90.03 32.97C90.03 34.0525 90.9076 34.93 91.99 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M73.98 16.93C75.0625 16.93 75.94 16.0525 75.94 14.97C75.94 13.8875 75.0625 13.01 73.98 13.01C72.8975 13.01 72.02 13.8875 72.02 14.97C72.02 16.0525 72.8975 16.93 73.98 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M73.98 34.93C75.0625 34.93 75.94 34.0525 75.94 32.97C75.94 31.8875 75.0625 31.01 73.98 31.01C72.8975 31.01 72.02 31.8875 72.02 32.97C72.02 34.0525 72.8975 34.93 73.98 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M55.98 16.93C57.0625 16.93 57.94 16.0525 57.94 14.97C57.94 13.8875 57.0625 13.01 55.98 13.01C54.8975 13.01 54.02 13.8875 54.02 14.97C54.02 16.0525 54.8975 16.93 55.98 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M55.98 34.93C57.0625 34.93 57.94 34.0525 57.94 32.97C57.94 31.8875 57.0625 31.01 55.98 31.01C54.8975 31.01 54.02 31.8875 54.02 32.97C54.02 34.0525 54.8975 34.93 55.98 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.97 16.93C39.0525 16.93 39.93 16.0525 39.93 14.97C39.93 13.8875 39.0525 13.01 37.97 13.01C36.8875 13.01 36.01 13.8875 36.01 14.97C36.01 16.0525 36.8875 16.93 37.97 16.93Z",
    fill: "#FF3E6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M37.97 34.93C39.0525 34.93 39.93 34.0525 39.93 32.97C39.93 31.8875 39.0525 31.01 37.97 31.01C36.8875 31.01 36.01 31.8875 36.01 32.97C36.01 34.0525 36.8875 34.93 37.97 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M19.97 16.93C21.0525 16.93 21.93 16.0525 21.93 14.97C21.93 13.8875 21.0525 13.01 19.97 13.01C18.8875 13.01 18.01 13.8875 18.01 14.97C18.01 16.0525 18.8875 16.93 19.97 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M19.97 34.93C21.0525 34.93 21.93 34.0525 21.93 32.97C21.93 31.8875 21.0525 31.01 19.97 31.01C18.8875 31.01 18.01 31.8875 18.01 32.97C18.01 34.0525 18.8875 34.93 19.97 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1.96 16.93C3.04248 16.93 3.92 16.0525 3.92 14.97C3.92 13.8875 3.04248 13.01 1.96 13.01C0.877522 13.01 0 13.8875 0 14.97C0 16.0525 0.877522 16.93 1.96 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1.96 34.93C3.04248 34.93 3.92 34.0525 3.92 32.97C3.92 31.8875 3.04248 31.01 1.96 31.01C0.877522 31.01 0 31.8875 0 32.97C0 34.0525 0.877522 34.93 1.96 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M506.04 16.93C507.122 16.93 508 16.0525 508 14.97C508 13.8875 507.122 13.01 506.04 13.01C504.958 13.01 504.08 13.8875 504.08 14.97C504.08 16.0525 504.958 16.93 506.04 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M506.04 34.93C507.122 34.93 508 34.0525 508 32.97C508 31.8875 507.122 31.01 506.04 31.01C504.958 31.01 504.08 31.8875 504.08 32.97C504.08 34.0525 504.958 34.93 506.04 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M488.03 16.93C489.112 16.93 489.99 16.0525 489.99 14.97C489.99 13.8875 489.112 13.01 488.03 13.01C486.948 13.01 486.07 13.8875 486.07 14.97C486.07 16.0525 486.948 16.93 488.03 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M488.03 34.93C489.112 34.93 489.99 34.0525 489.99 32.97C489.99 31.8875 489.112 31.01 488.03 31.01C486.948 31.01 486.07 31.8875 486.07 32.97C486.07 34.0525 486.948 34.93 488.03 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M470.03 16.93C471.112 16.93 471.99 16.0525 471.99 14.97C471.99 13.8875 471.112 13.01 470.03 13.01C468.948 13.01 468.07 13.8875 468.07 14.97C468.07 16.0525 468.948 16.93 470.03 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M470.03 34.93C471.112 34.93 471.99 34.0525 471.99 32.97C471.99 31.8875 471.112 31.01 470.03 31.01C468.948 31.01 468.07 31.8875 468.07 32.97C468.07 34.0525 468.948 34.93 470.03 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M452.02 16.93C453.102 16.93 453.98 16.0525 453.98 14.97C453.98 13.8875 453.102 13.01 452.02 13.01C450.938 13.01 450.06 13.8875 450.06 14.97C450.06 16.0525 450.938 16.93 452.02 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M452.02 34.93C453.102 34.93 453.98 34.0525 453.98 32.97C453.98 31.8875 453.102 31.01 452.02 31.01C450.938 31.01 450.06 31.8875 450.06 32.97C450.06 34.0525 450.938 34.93 452.02 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M434.02 16.93C435.102 16.93 435.98 16.0525 435.98 14.97C435.98 13.8875 435.102 13.01 434.02 13.01C432.938 13.01 432.06 13.8875 432.06 14.97C432.06 16.0525 432.938 16.93 434.02 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M434.02 34.93C435.102 34.93 435.98 34.0525 435.98 32.97C435.98 31.8875 435.102 31.01 434.02 31.01C432.938 31.01 432.06 31.8875 432.06 32.97C432.06 34.0525 432.938 34.93 434.02 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M416.01 16.93C417.092 16.93 417.97 16.0525 417.97 14.97C417.97 13.8875 417.092 13.01 416.01 13.01C414.928 13.01 414.05 13.8875 414.05 14.97C414.05 16.0525 414.928 16.93 416.01 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M416.01 34.93C417.092 34.93 417.97 34.0525 417.97 32.97C417.97 31.8875 417.092 31.01 416.01 31.01C414.928 31.01 414.05 31.8875 414.05 32.97C414.05 34.0525 414.928 34.93 416.01 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M398.01 16.93C399.092 16.93 399.97 16.0525 399.97 14.97C399.97 13.8875 399.092 13.01 398.01 13.01C396.928 13.01 396.05 13.8875 396.05 14.97C396.05 16.0525 396.928 16.93 398.01 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M398.01 34.93C399.092 34.93 399.97 34.0525 399.97 32.97C399.97 31.8875 399.092 31.01 398.01 31.01C396.928 31.01 396.05 31.8875 396.05 32.97C396.05 34.0525 396.928 34.93 398.01 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M380 16.93C381.082 16.93 381.96 16.0525 381.96 14.97C381.96 13.8875 381.082 13.01 380 13.01C378.918 13.01 378.04 13.8875 378.04 14.97C378.04 16.0525 378.918 16.93 380 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M380 34.93C381.082 34.93 381.96 34.0525 381.96 32.97C381.96 31.8875 381.082 31.01 380 31.01C378.918 31.01 378.04 31.8875 378.04 32.97C378.04 34.0525 378.918 34.93 380 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M361.99 16.93C363.072 16.93 363.95 16.0525 363.95 14.97C363.95 13.8875 363.072 13.01 361.99 13.01C360.908 13.01 360.03 13.8875 360.03 14.97C360.03 16.0525 360.908 16.93 361.99 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M361.99 34.93C363.072 34.93 363.95 34.0525 363.95 32.97C363.95 31.8875 363.072 31.01 361.99 31.01C360.908 31.01 360.03 31.8875 360.03 32.97C360.03 34.0525 360.908 34.93 361.99 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M343.99 16.93C345.072 16.93 345.95 16.0525 345.95 14.97C345.95 13.8875 345.072 13.01 343.99 13.01C342.908 13.01 342.03 13.8875 342.03 14.97C342.03 16.0525 342.908 16.93 343.99 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M343.99 34.93C345.072 34.93 345.95 34.0525 345.95 32.97C345.95 31.8875 345.072 31.01 343.99 31.01C342.908 31.01 342.03 31.8875 342.03 32.97C342.03 34.0525 342.908 34.93 343.99 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M325.98 16.93C327.062 16.93 327.94 16.0525 327.94 14.97C327.94 13.8875 327.062 13.01 325.98 13.01C324.898 13.01 324.02 13.8875 324.02 14.97C324.02 16.0525 324.898 16.93 325.98 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M325.98 34.93C327.062 34.93 327.94 34.0525 327.94 32.97C327.94 31.8875 327.062 31.01 325.98 31.01C324.898 31.01 324.02 31.8875 324.02 32.97C324.02 34.0525 324.898 34.93 325.98 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M307.98 16.93C309.062 16.93 309.94 16.0525 309.94 14.97C309.94 13.8875 309.062 13.01 307.98 13.01C306.898 13.01 306.02 13.8875 306.02 14.97C306.02 16.0525 306.898 16.93 307.98 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M307.98 34.93C309.062 34.93 309.94 34.0525 309.94 32.97C309.94 31.8875 309.062 31.01 307.98 31.01C306.898 31.01 306.02 31.8875 306.02 32.97C306.02 34.0525 306.898 34.93 307.98 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.97 16.93C291.052 16.93 291.93 16.0525 291.93 14.97C291.93 13.8875 291.052 13.01 289.97 13.01C288.888 13.01 288.01 13.8875 288.01 14.97C288.01 16.0525 288.888 16.93 289.97 16.93Z",
    fill: "#FF3E6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M289.97 34.93C291.052 34.93 291.93 34.0525 291.93 32.97C291.93 31.8875 291.052 31.01 289.97 31.01C288.888 31.01 288.01 31.8875 288.01 32.97C288.01 34.0525 288.888 34.93 289.97 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M271.97 16.93C273.052 16.93 273.93 16.0525 273.93 14.97C273.93 13.8875 273.052 13.01 271.97 13.01C270.888 13.01 270.01 13.8875 270.01 14.97C270.01 16.0525 270.888 16.93 271.97 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M271.97 34.93C273.052 34.93 273.93 34.0525 273.93 32.97C273.93 31.8875 273.052 31.01 271.97 31.01C270.888 31.01 270.01 31.8875 270.01 32.97C270.01 34.0525 270.888 34.93 271.97 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M253.96 16.93C255.042 16.93 255.92 16.0525 255.92 14.97C255.92 13.8875 255.042 13.01 253.96 13.01C252.878 13.01 252 13.8875 252 14.97C252 16.0525 252.878 16.93 253.96 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M253.96 34.93C255.042 34.93 255.92 34.0525 255.92 32.97C255.92 31.8875 255.042 31.01 253.96 31.01C252.878 31.01 252 31.8875 252 32.97C252 34.0525 252.878 34.93 253.96 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M758.04 16.93C759.122 16.93 760 16.0525 760 14.97C760 13.8875 759.122 13.01 758.04 13.01C756.957 13.01 756.08 13.8875 756.08 14.97C756.08 16.0525 756.957 16.93 758.04 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M758.04 34.93C759.122 34.93 760 34.0525 760 32.97C760 31.8875 759.122 31.01 758.04 31.01C756.957 31.01 756.08 31.8875 756.08 32.97C756.08 34.0525 756.957 34.93 758.04 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M740.03 16.93C741.113 16.93 741.99 16.0525 741.99 14.97C741.99 13.8875 741.113 13.01 740.03 13.01C738.948 13.01 738.07 13.8875 738.07 14.97C738.07 16.0525 738.948 16.93 740.03 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M740.03 34.93C741.113 34.93 741.99 34.0525 741.99 32.97C741.99 31.8875 741.113 31.01 740.03 31.01C738.948 31.01 738.07 31.8875 738.07 32.97C738.07 34.0525 738.948 34.93 740.03 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M722.03 16.93C723.113 16.93 723.99 16.0525 723.99 14.97C723.99 13.8875 723.113 13.01 722.03 13.01C720.948 13.01 720.07 13.8875 720.07 14.97C720.07 16.0525 720.948 16.93 722.03 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M722.03 34.93C723.113 34.93 723.99 34.0525 723.99 32.97C723.99 31.8875 723.113 31.01 722.03 31.01C720.948 31.01 720.07 31.8875 720.07 32.97C720.07 34.0525 720.948 34.93 722.03 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M704.02 16.93C705.102 16.93 705.98 16.0525 705.98 14.97C705.98 13.8875 705.102 13.01 704.02 13.01C702.938 13.01 702.06 13.8875 702.06 14.97C702.06 16.0525 702.938 16.93 704.02 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M704.02 34.93C705.102 34.93 705.98 34.0525 705.98 32.97C705.98 31.8875 705.102 31.01 704.02 31.01C702.938 31.01 702.06 31.8875 702.06 32.97C702.06 34.0525 702.938 34.93 704.02 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M686.02 16.93C687.102 16.93 687.98 16.0525 687.98 14.97C687.98 13.8875 687.102 13.01 686.02 13.01C684.938 13.01 684.06 13.8875 684.06 14.97C684.06 16.0525 684.938 16.93 686.02 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M686.02 34.93C687.102 34.93 687.98 34.0525 687.98 32.97C687.98 31.8875 687.102 31.01 686.02 31.01C684.938 31.01 684.06 31.8875 684.06 32.97C684.06 34.0525 684.938 34.93 686.02 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M668.01 16.93C669.092 16.93 669.97 16.0525 669.97 14.97C669.97 13.8875 669.092 13.01 668.01 13.01C666.928 13.01 666.05 13.8875 666.05 14.97C666.05 16.0525 666.928 16.93 668.01 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M668.01 34.93C669.092 34.93 669.97 34.0525 669.97 32.97C669.97 31.8875 669.092 31.01 668.01 31.01C666.928 31.01 666.05 31.8875 666.05 32.97C666.05 34.0525 666.928 34.93 668.01 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M650.01 16.93C651.092 16.93 651.97 16.0525 651.97 14.97C651.97 13.8875 651.092 13.01 650.01 13.01C648.928 13.01 648.05 13.8875 648.05 14.97C648.05 16.0525 648.928 16.93 650.01 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M650.01 34.93C651.092 34.93 651.97 34.0525 651.97 32.97C651.97 31.8875 651.092 31.01 650.01 31.01C648.928 31.01 648.05 31.8875 648.05 32.97C648.05 34.0525 648.928 34.93 650.01 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M632 16.93C633.082 16.93 633.96 16.0525 633.96 14.97C633.96 13.8875 633.082 13.01 632 13.01C630.918 13.01 630.04 13.8875 630.04 14.97C630.04 16.0525 630.918 16.93 632 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M632 34.93C633.082 34.93 633.96 34.0525 633.96 32.97C633.96 31.8875 633.082 31.01 632 31.01C630.918 31.01 630.04 31.8875 630.04 32.97C630.04 34.0525 630.918 34.93 632 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M613.99 16.93C615.072 16.93 615.95 16.0525 615.95 14.97C615.95 13.8875 615.072 13.01 613.99 13.01C612.908 13.01 612.03 13.8875 612.03 14.97C612.03 16.0525 612.908 16.93 613.99 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M613.99 34.93C615.072 34.93 615.95 34.0525 615.95 32.97C615.95 31.8875 615.072 31.01 613.99 31.01C612.908 31.01 612.03 31.8875 612.03 32.97C612.03 34.0525 612.908 34.93 613.99 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M595.99 16.93C597.072 16.93 597.95 16.0525 597.95 14.97C597.95 13.8875 597.072 13.01 595.99 13.01C594.908 13.01 594.03 13.8875 594.03 14.97C594.03 16.0525 594.908 16.93 595.99 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M595.99 34.93C597.072 34.93 597.95 34.0525 597.95 32.97C597.95 31.8875 597.072 31.01 595.99 31.01C594.908 31.01 594.03 31.8875 594.03 32.97C594.03 34.0525 594.908 34.93 595.99 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M577.98 16.93C579.062 16.93 579.94 16.0525 579.94 14.97C579.94 13.8875 579.062 13.01 577.98 13.01C576.898 13.01 576.02 13.8875 576.02 14.97C576.02 16.0525 576.898 16.93 577.98 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M577.98 34.93C579.062 34.93 579.94 34.0525 579.94 32.97C579.94 31.8875 579.062 31.01 577.98 31.01C576.898 31.01 576.02 31.8875 576.02 32.97C576.02 34.0525 576.898 34.93 577.98 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M559.98 16.93C561.062 16.93 561.94 16.0525 561.94 14.97C561.94 13.8875 561.062 13.01 559.98 13.01C558.898 13.01 558.02 13.8875 558.02 14.97C558.02 16.0525 558.898 16.93 559.98 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M559.98 34.93C561.062 34.93 561.94 34.0525 561.94 32.97C561.94 31.8875 561.062 31.01 559.98 31.01C558.898 31.01 558.02 31.8875 558.02 32.97C558.02 34.0525 558.898 34.93 559.98 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.97 16.93C543.052 16.93 543.93 16.0525 543.93 14.97C543.93 13.8875 543.052 13.01 541.97 13.01C540.887 13.01 540.01 13.8875 540.01 14.97C540.01 16.0525 540.887 16.93 541.97 16.93Z",
    fill: "#FF3E6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M541.97 34.93C543.052 34.93 543.93 34.0525 543.93 32.97C543.93 31.8875 543.052 31.01 541.97 31.01C540.887 31.01 540.01 31.8875 540.01 32.97C540.01 34.0525 540.887 34.93 541.97 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M523.97 16.93C525.052 16.93 525.93 16.0525 525.93 14.97C525.93 13.8875 525.052 13.01 523.97 13.01C522.887 13.01 522.01 13.8875 522.01 14.97C522.01 16.0525 522.887 16.93 523.97 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M523.97 34.93C525.052 34.93 525.93 34.0525 525.93 32.97C525.93 31.8875 525.052 31.01 523.97 31.01C522.887 31.01 522.01 31.8875 522.01 32.97C522.01 34.0525 522.887 34.93 523.97 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M505.96 16.93C507.042 16.93 507.92 16.0525 507.92 14.97C507.92 13.8875 507.042 13.01 505.96 13.01C504.878 13.01 504 13.8875 504 14.97C504 16.0525 504.878 16.93 505.96 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M505.96 34.93C507.042 34.93 507.92 34.0525 507.92 32.97C507.92 31.8875 507.042 31.01 505.96 31.01C504.878 31.01 504 31.8875 504 32.97C504 34.0525 504.878 34.93 505.96 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1261.96 34.93C1263.04 34.93 1263.92 34.0525 1263.92 32.97C1263.92 31.8875 1263.04 31.01 1261.96 31.01C1260.88 31.01 1260 31.8875 1260 32.97C1260 34.0525 1260.88 34.93 1261.96 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1261.96 16.93C1263.04 16.93 1263.92 16.0525 1263.92 14.97C1263.92 13.8875 1263.04 13.01 1261.96 13.01C1260.88 13.01 1260 13.8875 1260 14.97C1260 16.0525 1260.88 16.93 1261.96 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1279.97 34.93C1281.05 34.93 1281.93 34.0525 1281.93 32.97C1281.93 31.8875 1281.05 31.01 1279.97 31.01C1278.89 31.01 1278.01 31.8875 1278.01 32.97C1278.01 34.0525 1278.89 34.93 1279.97 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1279.97 16.93C1281.05 16.93 1281.93 16.0525 1281.93 14.97C1281.93 13.8875 1281.05 13.01 1279.97 13.01C1278.89 13.01 1278.01 13.8875 1278.01 14.97C1278.01 16.0525 1278.89 16.93 1279.97 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1297.97 34.93C1299.05 34.93 1299.93 34.0525 1299.93 32.97C1299.93 31.8875 1299.05 31.01 1297.97 31.01C1296.89 31.01 1296.01 31.8875 1296.01 32.97C1296.01 34.0525 1296.89 34.93 1297.97 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1297.97 16.93C1299.05 16.93 1299.93 16.0525 1299.93 14.97C1299.93 13.8875 1299.05 13.01 1297.97 13.01C1296.89 13.01 1296.01 13.8875 1296.01 14.97C1296.01 16.0525 1296.89 16.93 1297.97 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1315.98 34.93C1317.06 34.93 1317.94 34.0525 1317.94 32.97C1317.94 31.8875 1317.06 31.01 1315.98 31.01C1314.9 31.01 1314.02 31.8875 1314.02 32.97C1314.02 34.0525 1314.9 34.93 1315.98 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1315.98 16.93C1317.06 16.93 1317.94 16.0525 1317.94 14.97C1317.94 13.8875 1317.06 13.01 1315.98 13.01C1314.9 13.01 1314.02 13.8875 1314.02 14.97C1314.02 16.0525 1314.9 16.93 1315.98 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1333.98 34.93C1335.06 34.93 1335.94 34.0525 1335.94 32.97C1335.94 31.8875 1335.06 31.01 1333.98 31.01C1332.9 31.01 1332.02 31.8875 1332.02 32.97C1332.02 34.0525 1332.9 34.93 1333.98 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1333.98 16.93C1335.06 16.93 1335.94 16.0525 1335.94 14.97C1335.94 13.8875 1335.06 13.01 1333.98 13.01C1332.9 13.01 1332.02 13.8875 1332.02 14.97C1332.02 16.0525 1332.9 16.93 1333.98 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1351.99 34.93C1353.07 34.93 1353.95 34.0525 1353.95 32.97C1353.95 31.8875 1353.07 31.01 1351.99 31.01C1350.91 31.01 1350.03 31.8875 1350.03 32.97C1350.03 34.0525 1350.91 34.93 1351.99 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1351.99 16.93C1353.07 16.93 1353.95 16.0525 1353.95 14.97C1353.95 13.8875 1353.07 13.01 1351.99 13.01C1350.91 13.01 1350.03 13.8875 1350.03 14.97C1350.03 16.0525 1350.91 16.93 1351.99 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1369.99 34.93C1371.07 34.93 1371.95 34.0525 1371.95 32.97C1371.95 31.8875 1371.07 31.01 1369.99 31.01C1368.91 31.01 1368.03 31.8875 1368.03 32.97C1368.03 34.0525 1368.91 34.93 1369.99 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1369.99 16.93C1371.07 16.93 1371.95 16.0525 1371.95 14.97C1371.95 13.8875 1371.07 13.01 1369.99 13.01C1368.91 13.01 1368.03 13.8875 1368.03 14.97C1368.03 16.0525 1368.91 16.93 1369.99 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1388 34.93C1389.08 34.93 1389.96 34.0525 1389.96 32.97C1389.96 31.8875 1389.08 31.01 1388 31.01C1386.92 31.01 1386.04 31.8875 1386.04 32.97C1386.04 34.0525 1386.92 34.93 1388 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1388 16.93C1389.08 16.93 1389.96 16.0525 1389.96 14.97C1389.96 13.8875 1389.08 13.01 1388 13.01C1386.92 13.01 1386.04 13.8875 1386.04 14.97C1386.04 16.0525 1386.92 16.93 1388 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1406.01 34.93C1407.09 34.93 1407.97 34.0525 1407.97 32.97C1407.97 31.8875 1407.09 31.01 1406.01 31.01C1404.93 31.01 1404.05 31.8875 1404.05 32.97C1404.05 34.0525 1404.93 34.93 1406.01 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1406.01 16.93C1407.09 16.93 1407.97 16.0525 1407.97 14.97C1407.97 13.8875 1407.09 13.01 1406.01 13.01C1404.93 13.01 1404.05 13.8875 1404.05 14.97C1404.05 16.0525 1404.93 16.93 1406.01 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1424.01 34.93C1425.09 34.93 1425.97 34.0525 1425.97 32.97C1425.97 31.8875 1425.09 31.01 1424.01 31.01C1422.93 31.01 1422.05 31.8875 1422.05 32.97C1422.05 34.0525 1422.93 34.93 1424.01 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1424.01 16.93C1425.09 16.93 1425.97 16.0525 1425.97 14.97C1425.97 13.8875 1425.09 13.01 1424.01 13.01C1422.93 13.01 1422.05 13.8875 1422.05 14.97C1422.05 16.0525 1422.93 16.93 1424.01 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1009.96 34.93C1011.04 34.93 1011.92 34.0525 1011.92 32.97C1011.92 31.8875 1011.04 31.01 1009.96 31.01C1008.88 31.01 1008 31.8875 1008 32.97C1008 34.0525 1008.88 34.93 1009.96 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1009.96 16.93C1011.04 16.93 1011.92 16.0525 1011.92 14.97C1011.92 13.8875 1011.04 13.01 1009.96 13.01C1008.88 13.01 1008 13.8875 1008 14.97C1008 16.0525 1008.88 16.93 1009.96 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1027.97 34.93C1029.05 34.93 1029.93 34.0525 1029.93 32.97C1029.93 31.8875 1029.05 31.01 1027.97 31.01C1026.89 31.01 1026.01 31.8875 1026.01 32.97C1026.01 34.0525 1026.89 34.93 1027.97 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1027.97 16.93C1029.05 16.93 1029.93 16.0525 1029.93 14.97C1029.93 13.8875 1029.05 13.01 1027.97 13.01C1026.89 13.01 1026.01 13.8875 1026.01 14.97C1026.01 16.0525 1026.89 16.93 1027.97 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1045.97 34.93C1047.05 34.93 1047.93 34.0525 1047.93 32.97C1047.93 31.8875 1047.05 31.01 1045.97 31.01C1044.89 31.01 1044.01 31.8875 1044.01 32.97C1044.01 34.0525 1044.89 34.93 1045.97 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1045.97 16.93C1047.05 16.93 1047.93 16.0525 1047.93 14.97C1047.93 13.8875 1047.05 13.01 1045.97 13.01C1044.89 13.01 1044.01 13.8875 1044.01 14.97C1044.01 16.0525 1044.89 16.93 1045.97 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1063.98 34.93C1065.06 34.93 1065.94 34.0525 1065.94 32.97C1065.94 31.8875 1065.06 31.01 1063.98 31.01C1062.9 31.01 1062.02 31.8875 1062.02 32.97C1062.02 34.0525 1062.9 34.93 1063.98 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1063.98 16.93C1065.06 16.93 1065.94 16.0525 1065.94 14.97C1065.94 13.8875 1065.06 13.01 1063.98 13.01C1062.9 13.01 1062.02 13.8875 1062.02 14.97C1062.02 16.0525 1062.9 16.93 1063.98 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1081.98 34.93C1083.06 34.93 1083.94 34.0525 1083.94 32.97C1083.94 31.8875 1083.06 31.01 1081.98 31.01C1080.9 31.01 1080.02 31.8875 1080.02 32.97C1080.02 34.0525 1080.9 34.93 1081.98 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1081.98 16.93C1083.06 16.93 1083.94 16.0525 1083.94 14.97C1083.94 13.8875 1083.06 13.01 1081.98 13.01C1080.9 13.01 1080.02 13.8875 1080.02 14.97C1080.02 16.0525 1080.9 16.93 1081.98 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1099.99 34.93C1101.07 34.93 1101.95 34.0525 1101.95 32.97C1101.95 31.8875 1101.07 31.01 1099.99 31.01C1098.91 31.01 1098.03 31.8875 1098.03 32.97C1098.03 34.0525 1098.91 34.93 1099.99 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1099.99 16.93C1101.07 16.93 1101.95 16.0525 1101.95 14.97C1101.95 13.8875 1101.07 13.01 1099.99 13.01C1098.91 13.01 1098.03 13.8875 1098.03 14.97C1098.03 16.0525 1098.91 16.93 1099.99 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1117.99 34.93C1119.07 34.93 1119.95 34.0525 1119.95 32.97C1119.95 31.8875 1119.07 31.01 1117.99 31.01C1116.91 31.01 1116.03 31.8875 1116.03 32.97C1116.03 34.0525 1116.91 34.93 1117.99 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1117.99 16.93C1119.07 16.93 1119.95 16.0525 1119.95 14.97C1119.95 13.8875 1119.07 13.01 1117.99 13.01C1116.91 13.01 1116.03 13.8875 1116.03 14.97C1116.03 16.0525 1116.91 16.93 1117.99 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1136 34.93C1137.08 34.93 1137.96 34.0525 1137.96 32.97C1137.96 31.8875 1137.08 31.01 1136 31.01C1134.92 31.01 1134.04 31.8875 1134.04 32.97C1134.04 34.0525 1134.92 34.93 1136 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1136 16.93C1137.08 16.93 1137.96 16.0525 1137.96 14.97C1137.96 13.8875 1137.08 13.01 1136 13.01C1134.92 13.01 1134.04 13.8875 1134.04 14.97C1134.04 16.0525 1134.92 16.93 1136 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1154.01 34.93C1155.09 34.93 1155.97 34.0525 1155.97 32.97C1155.97 31.8875 1155.09 31.01 1154.01 31.01C1152.93 31.01 1152.05 31.8875 1152.05 32.97C1152.05 34.0525 1152.93 34.93 1154.01 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1154.01 16.93C1155.09 16.93 1155.97 16.0525 1155.97 14.97C1155.97 13.8875 1155.09 13.01 1154.01 13.01C1152.93 13.01 1152.05 13.8875 1152.05 14.97C1152.05 16.0525 1152.93 16.93 1154.01 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1172.01 34.93C1173.09 34.93 1173.97 34.0525 1173.97 32.97C1173.97 31.8875 1173.09 31.01 1172.01 31.01C1170.93 31.01 1170.05 31.8875 1170.05 32.97C1170.05 34.0525 1170.93 34.93 1172.01 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1172.01 16.93C1173.09 16.93 1173.97 16.0525 1173.97 14.97C1173.97 13.8875 1173.09 13.01 1172.01 13.01C1170.93 13.01 1170.05 13.8875 1170.05 14.97C1170.05 16.0525 1170.93 16.93 1172.01 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1190.02 34.93C1191.1 34.93 1191.98 34.0525 1191.98 32.97C1191.98 31.8875 1191.1 31.01 1190.02 31.01C1188.94 31.01 1188.06 31.8875 1188.06 32.97C1188.06 34.0525 1188.94 34.93 1190.02 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1190.02 16.93C1191.1 16.93 1191.98 16.0525 1191.98 14.97C1191.98 13.8875 1191.1 13.01 1190.02 13.01C1188.94 13.01 1188.06 13.8875 1188.06 14.97C1188.06 16.0525 1188.94 16.93 1190.02 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1208.02 34.93C1209.1 34.93 1209.98 34.0525 1209.98 32.97C1209.98 31.8875 1209.1 31.01 1208.02 31.01C1206.94 31.01 1206.06 31.8875 1206.06 32.97C1206.06 34.0525 1206.94 34.93 1208.02 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1208.02 16.93C1209.1 16.93 1209.98 16.0525 1209.98 14.97C1209.98 13.8875 1209.1 13.01 1208.02 13.01C1206.94 13.01 1206.06 13.8875 1206.06 14.97C1206.06 16.0525 1206.94 16.93 1208.02 16.93Z",
    fill: "#FF3E6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1226.03 34.93C1227.11 34.93 1227.99 34.0525 1227.99 32.97C1227.99 31.8875 1227.11 31.01 1226.03 31.01C1224.95 31.01 1224.07 31.8875 1224.07 32.97C1224.07 34.0525 1224.95 34.93 1226.03 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1226.03 16.93C1227.11 16.93 1227.99 16.0525 1227.99 14.97C1227.99 13.8875 1227.11 13.01 1226.03 13.01C1224.95 13.01 1224.07 13.8875 1224.07 14.97C1224.07 16.0525 1224.95 16.93 1226.03 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1244.03 34.93C1245.11 34.93 1245.99 34.0525 1245.99 32.97C1245.99 31.8875 1245.11 31.01 1244.03 31.01C1242.95 31.01 1242.07 31.8875 1242.07 32.97C1242.07 34.0525 1242.95 34.93 1244.03 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1244.03 16.93C1245.11 16.93 1245.99 16.0525 1245.99 14.97C1245.99 13.8875 1245.11 13.01 1244.03 13.01C1242.95 13.01 1242.07 13.8875 1242.07 14.97C1242.07 16.0525 1242.95 16.93 1244.03 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1262.04 34.93C1263.12 34.93 1264 34.0525 1264 32.97C1264 31.8875 1263.12 31.01 1262.04 31.01C1260.96 31.01 1260.08 31.8875 1260.08 32.97C1260.08 34.0525 1260.96 34.93 1262.04 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1262.04 16.93C1263.12 16.93 1264 16.0525 1264 14.97C1264 13.8875 1263.12 13.01 1262.04 13.01C1260.96 13.01 1260.08 13.8875 1260.08 14.97C1260.08 16.0525 1260.96 16.93 1262.04 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M757.96 34.93C759.043 34.93 759.92 34.0525 759.92 32.97C759.92 31.8875 759.043 31.01 757.96 31.01C756.878 31.01 756 31.8875 756 32.97C756 34.0525 756.878 34.93 757.96 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M757.96 16.93C759.043 16.93 759.92 16.0525 759.92 14.97C759.92 13.8875 759.043 13.01 757.96 13.01C756.878 13.01 756 13.8875 756 14.97C756 16.0525 756.878 16.93 757.96 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M775.97 34.93C777.052 34.93 777.93 34.0525 777.93 32.97C777.93 31.8875 777.052 31.01 775.97 31.01C774.887 31.01 774.01 31.8875 774.01 32.97C774.01 34.0525 774.887 34.93 775.97 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M775.97 16.93C777.052 16.93 777.93 16.0525 777.93 14.97C777.93 13.8875 777.052 13.01 775.97 13.01C774.887 13.01 774.01 13.8875 774.01 14.97C774.01 16.0525 774.887 16.93 775.97 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M793.97 34.93C795.052 34.93 795.93 34.0525 795.93 32.97C795.93 31.8875 795.052 31.01 793.97 31.01C792.887 31.01 792.01 31.8875 792.01 32.97C792.01 34.0525 792.887 34.93 793.97 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M793.97 16.93C795.052 16.93 795.93 16.0525 795.93 14.97C795.93 13.8875 795.052 13.01 793.97 13.01C792.887 13.01 792.01 13.8875 792.01 14.97C792.01 16.0525 792.887 16.93 793.97 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M811.98 34.93C813.062 34.93 813.94 34.0525 813.94 32.97C813.94 31.8875 813.062 31.01 811.98 31.01C810.898 31.01 810.02 31.8875 810.02 32.97C810.02 34.0525 810.898 34.93 811.98 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M811.98 16.93C813.062 16.93 813.94 16.0525 813.94 14.97C813.94 13.8875 813.062 13.01 811.98 13.01C810.898 13.01 810.02 13.8875 810.02 14.97C810.02 16.0525 810.898 16.93 811.98 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M829.98 34.93C831.062 34.93 831.94 34.0525 831.94 32.97C831.94 31.8875 831.062 31.01 829.98 31.01C828.898 31.01 828.02 31.8875 828.02 32.97C828.02 34.0525 828.898 34.93 829.98 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M829.98 16.93C831.062 16.93 831.94 16.0525 831.94 14.97C831.94 13.8875 831.062 13.01 829.98 13.01C828.898 13.01 828.02 13.8875 828.02 14.97C828.02 16.0525 828.898 16.93 829.98 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M847.99 34.93C849.072 34.93 849.95 34.0525 849.95 32.97C849.95 31.8875 849.072 31.01 847.99 31.01C846.908 31.01 846.03 31.8875 846.03 32.97C846.03 34.0525 846.908 34.93 847.99 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M847.99 16.93C849.072 16.93 849.95 16.0525 849.95 14.97C849.95 13.8875 849.072 13.01 847.99 13.01C846.908 13.01 846.03 13.8875 846.03 14.97C846.03 16.0525 846.908 16.93 847.99 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M865.99 34.93C867.072 34.93 867.95 34.0525 867.95 32.97C867.95 31.8875 867.072 31.01 865.99 31.01C864.908 31.01 864.03 31.8875 864.03 32.97C864.03 34.0525 864.908 34.93 865.99 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M865.99 16.93C867.072 16.93 867.95 16.0525 867.95 14.97C867.95 13.8875 867.072 13.01 865.99 13.01C864.908 13.01 864.03 13.8875 864.03 14.97C864.03 16.0525 864.908 16.93 865.99 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M884 34.93C885.082 34.93 885.96 34.0525 885.96 32.97C885.96 31.8875 885.082 31.01 884 31.01C882.918 31.01 882.04 31.8875 882.04 32.97C882.04 34.0525 882.918 34.93 884 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M884 16.93C885.082 16.93 885.96 16.0525 885.96 14.97C885.96 13.8875 885.082 13.01 884 13.01C882.918 13.01 882.04 13.8875 882.04 14.97C882.04 16.0525 882.918 16.93 884 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M902.01 34.93C903.092 34.93 903.97 34.0525 903.97 32.97C903.97 31.8875 903.092 31.01 902.01 31.01C900.928 31.01 900.05 31.8875 900.05 32.97C900.05 34.0525 900.928 34.93 902.01 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M902.01 16.93C903.092 16.93 903.97 16.0525 903.97 14.97C903.97 13.8875 903.092 13.01 902.01 13.01C900.928 13.01 900.05 13.8875 900.05 14.97C900.05 16.0525 900.928 16.93 902.01 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M920.01 34.93C921.092 34.93 921.97 34.0525 921.97 32.97C921.97 31.8875 921.092 31.01 920.01 31.01C918.928 31.01 918.05 31.8875 918.05 32.97C918.05 34.0525 918.928 34.93 920.01 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M920.01 16.93C921.092 16.93 921.97 16.0525 921.97 14.97C921.97 13.8875 921.092 13.01 920.01 13.01C918.928 13.01 918.05 13.8875 918.05 14.97C918.05 16.0525 918.928 16.93 920.01 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M938.02 34.93C939.102 34.93 939.98 34.0525 939.98 32.97C939.98 31.8875 939.102 31.01 938.02 31.01C936.938 31.01 936.06 31.8875 936.06 32.97C936.06 34.0525 936.938 34.93 938.02 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M938.02 16.93C939.102 16.93 939.98 16.0525 939.98 14.97C939.98 13.8875 939.102 13.01 938.02 13.01C936.938 13.01 936.06 13.8875 936.06 14.97C936.06 16.0525 936.938 16.93 938.02 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M956.02 34.93C957.102 34.93 957.98 34.0525 957.98 32.97C957.98 31.8875 957.102 31.01 956.02 31.01C954.938 31.01 954.06 31.8875 954.06 32.97C954.06 34.0525 954.938 34.93 956.02 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M956.02 16.93C957.102 16.93 957.98 16.0525 957.98 14.97C957.98 13.8875 957.102 13.01 956.02 13.01C954.938 13.01 954.06 13.8875 954.06 14.97C954.06 16.0525 954.938 16.93 956.02 16.93Z",
    fill: "#FF3E6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M974.03 34.93C975.113 34.93 975.99 34.0525 975.99 32.97C975.99 31.8875 975.113 31.01 974.03 31.01C972.948 31.01 972.07 31.8875 972.07 32.97C972.07 34.0525 972.948 34.93 974.03 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M974.03 16.93C975.113 16.93 975.99 16.0525 975.99 14.97C975.99 13.8875 975.113 13.01 974.03 13.01C972.948 13.01 972.07 13.8875 972.07 14.97C972.07 16.0525 972.948 16.93 974.03 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M992.03 34.93C993.113 34.93 993.99 34.0525 993.99 32.97C993.99 31.8875 993.113 31.01 992.03 31.01C990.948 31.01 990.07 31.8875 990.07 32.97C990.07 34.0525 990.948 34.93 992.03 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M992.03 16.93C993.113 16.93 993.99 16.0525 993.99 14.97C993.99 13.8875 993.113 13.01 992.03 13.01C990.948 13.01 990.07 13.8875 990.07 14.97C990.07 16.0525 990.948 16.93 992.03 16.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1010.04 34.93C1011.12 34.93 1012 34.0525 1012 32.97C1012 31.8875 1011.12 31.01 1010.04 31.01C1008.96 31.01 1008.08 31.8875 1008.08 32.97C1008.08 34.0525 1008.96 34.93 1010.04 34.93Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1010.04 16.93C1011.12 16.93 1012 16.0525 1012 14.97C1012 13.8875 1011.12 13.01 1010.04 13.01C1008.96 13.01 1008.08 13.8875 1008.08 14.97C1008.08 16.0525 1008.96 16.93 1010.04 16.93Z",
    fill: "#050912"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_9298"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 44,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1_9298"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1516,
    height: 256,
    fill: "white",
    transform: "translate(0 -5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots5);
export default __webpack_public_path__ + "static/media/dots-5.8fde07f27842e928b0ba48f2d9deb60a.svg";
export { ForwardRef as ReactComponent };